<template>
  <b-alert
    :show="hasPending"
    variant="warning"
    class="text-center mb-0 rounded-0 py-3 pending-token-banner"
  >
    <strong>
      {{ pendingTokenInvitations.length }} accepted invitation{{
        pendingTokenInvitations.length === 1 ? '' : 's'
      }}
      <template v-if="isFree"> ready to add. </template>
      <template v-else> awaiting a token. </template>
    </strong>
    <template v-if="isFree">Add</template>
    <template v-else>Apply a token to add</template>
    {{ pendingTokenInvitations.length === 1 ? 'them' : 'these candidates' }} to
    your workforce.
    <b-link class="pending-token-banner__cta ml-2" @click="$emit('review')">
      Review
    </b-link>
  </b-alert>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'

// Candidates-section-scoped equivalent of MainLayout's
// `profile-completion-banner` — a persistent, non-dismissible b-alert with a
// CTA. Deliberately NOT rendered in MainLayout.vue: it's only relevant while
// inside the OTW candidates area, so it lives in views/candidates/index.vue.
export default {
  name: 'PendingTokenBanner',

  computed: {
    ...mapGetters('candidate', ['pendingTokenInvitations']),
    ...mapGetters('auth', ['user']),

    // Free tier / trial — same `is_free` flag the router and the token modal
    // gate on. These companies finish an accepted invitation with a plain
    // "add to workforce" (the API applies its free bypass), no token, so this
    // banner drops the token wording for them.
    isFree() {
      return !!(this.user && this.user.is_free)
    },

    hasPending() {
      return (
        Array.isArray(this.pendingTokenInvitations) &&
        this.pendingTokenInvitations.length > 0
      )
    },
  },

  created() {
    this.fetchPendingTokenInvitations().catch(() => {})
  },

  methods: {
    ...mapActions('candidate', ['fetchPendingTokenInvitations']),
  },
}
</script>

<style lang="scss" scoped>
.pending-token-banner__cta {
  font-weight: 600;
  text-decoration: underline;
}
</style>
